import { render, staticRenderFns } from "./IngestReports.vue?vue&type=template&id=2ca99ac5&scoped=true"
import script from "./IngestReports.vue?vue&type=script&lang=js"
export * from "./IngestReports.vue?vue&type=script&lang=js"
import style0 from "./IngestReports.vue?vue&type=style&index=0&id=2ca99ac5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca99ac5",
  null
  
)

export default component.exports